module.exports = __webpack_public_path__ + "static/media/facebook.80f963ec.svg";